var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.999,
    height: 41.509,
    viewBox: "0 0 37.999 41.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_188",
    x: 0,
    y: 0,
    width: 37.999,
    height: 41.509,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_189",
    x: 16.972,
    y: 16.78,
    width: 16.36,
    height: 19.94,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.522
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_316",
    "data-name": "Groupe 316",
    transform: "translate(-149.829 74.014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 149.83, -74.01)",
    filter: "url(#Trac\\xE9_188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_188-2",
    "data-name": "Trac\\xE9 188",
    d: "M174.847-45.505c-.631-.127-1.261-.255-1.892-.38-.214-.043-.43-.076-.644-.117a.923.923,0,0,1-.77-1.123c.058-.322.121-.644.174-.967a.763.763,0,0,0-.022-.2.7.7,0,0,0-.212.059c-.265.177-.521.366-.784.546a.875.875,0,0,1-1.3-.191.411.411,0,0,0-.4-.148H155.549c-.6,0-.71-.111-.71-.721,0-1.366-.03-2.734.005-4.1a9.509,9.509,0,0,1,5.438-8.8,1.007,1.007,0,0,0,.094-.067l-.186-.218a7.082,7.082,0,0,1,1.973-10.827,6.514,6.514,0,0,1,8.7,2.662,7.133,7.133,0,0,1-.786,8.183c-.053.061-.1.125-.137.168.539.336,1.068.669,1.6.992a.273.273,0,0,0,.214-.017.907.907,0,0,1,1.205.3c.186.258.358.527.54.789.048.07.106.133.2.254.047-.148.081-.227.1-.308.06-.313.11-.627.17-.94a.906.906,0,0,1,1.1-.76q1.262.229,2.523.463a.918.918,0,0,1,.808,1.141c-.047.3-.109.59-.156.887a2.917,2.917,0,0,0,0,.374l.956-.669a.913.913,0,0,1,1.429.253q.707,1.039,1.406,2.082a.93.93,0,0,1-.26,1.4c-.244.175-.495.341-.735.521a.87.87,0,0,0-.148.2.955.955,0,0,0,.2.1,5.828,5.828,0,0,0,.644.117,1.169,1.169,0,0,1,1.084.81v.437a1.492,1.492,0,0,0-.055.178c-.143.778-.28,1.557-.426,2.335A.92.92,0,0,1,181.16-50c-.3-.054-.59-.113-.886-.161a.622.622,0,0,0-.194.032.622.622,0,0,0,.05.189c.184.282.378.557.564.838a.911.911,0,0,1-.229,1.32q-1.087.78-2.188,1.539a.884.884,0,0,1-1.255-.222c-.194-.264-.37-.541-.556-.81-.049-.07-.106-.135-.2-.255a2.716,2.716,0,0,0-.1.3c-.051.259-.109.517-.139.779a1.046,1.046,0,0,1-.739.949Zm-15.28-3.448c0-.768,0-1.522,0-2.275,0-.34.172-.542.442-.548s.458.211.459.559c0,.752,0,1.5,0,2.251h8.149a.436.436,0,0,0-.026-.078c-.234-.347-.471-.692-.7-1.04a.909.909,0,0,1,.222-1.341c.262-.2.532-.383.794-.58a.68.68,0,0,0,.117-.164.686.686,0,0,0-.19-.115c-.293-.063-.589-.113-.885-.166a.911.911,0,0,1-.8-1.125q.229-1.3.474-2.6a.913.913,0,0,1,1.154-.786c.3.057.607.118.912.168a.621.621,0,0,0,.194-.032.606.606,0,0,0-.047-.191c-.168-.26-.346-.513-.519-.77a.94.94,0,0,1,.269-1.454c.413-.292.827-.583,1.3-.917-.539-.283-1.03-.537-1.515-.8a.3.3,0,0,0-.365.053,6.408,6.408,0,0,1-7.673.039.409.409,0,0,0-.486-.05,8.5,8.5,0,0,0-5.068,7.44c-.111,1.449-.032,2.913-.037,4.37a.941.941,0,0,0,.025.156ZM165.148-72.6a5.551,5.551,0,0,0-2.133.435,6.165,6.165,0,0,0-2.267,9.49,5.572,5.572,0,0,0,7.927.86,6.134,6.134,0,0,0,1.708-7.221A5.672,5.672,0,0,0,165.148-72.6Zm14.68,14.032c-.4.279-.765.535-1.131.789a.512.512,0,0,1-.738,0c-.126-.089-.258-.17-.392-.248a.488.488,0,0,1-.283-.631c.082-.454.161-.908.245-1.382l-2.644-.514c-.074.389-.143.736-.2,1.085-.126.712-.125.712-.827.852-.036.007-.07.02-.105.029-.468.115-.531.09-.81-.321l-.727-1.067L170-58.429c.19.287.374.556.548.831.35.552.605.616.046,1.362-.307.41-.337.469-.84.372-.4-.077-.8-.145-1.219-.221l-.493,2.676a.814.814,0,0,0,.1.042q.614.131,1.228.259c.361.075.447.169.505.54a3.124,3.124,0,0,0,.086.427.534.534,0,0,1-.234.66c-.374.258-.739.529-1.123.8l1.517,2.273c.394-.274.777-.534,1.152-.805a.515.515,0,0,1,.7,0,3.113,3.113,0,0,0,.388.253c.308.178.363.286.3.645-.076.454-.157.908-.239,1.38l2.654.515c.091-.479.177-.915.258-1.353.074-.4.15-.475.56-.549.125-.022.251-.044.374-.076.377-.1.487-.059.71.268.256.374.512.749.775,1.135l2.21-1.549c-.22-.332-.4-.654-.627-.933a.782.782,0,0,1-.007-1.179.539.539,0,0,0,.07-.117c.212-.38.32-.428.749-.347s.837.154,1.28.235c.16-.872.32-1.719.463-2.569.009-.056-.1-.179-.173-.2-.39-.089-.785-.153-1.179-.227-.344-.064-.451-.176-.5-.51a4.678,4.678,0,0,0-.095-.481.522.522,0,0,1,.242-.632c.385-.257.758-.531,1.152-.809Z",
    transform: "translate(-149.83 74.01)",
    fill: "#50b2dc",
    stroke: "#50b2dc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 149.83, -74.01)",
    filter: "url(#Trac\\xE9_189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_189-2",
    "data-name": "Trac\\xE9 189",
    d: "M254.417,28.171a3.22,3.22,0,1,1,3.2-3.2A3.221,3.221,0,0,1,254.417,28.171Zm-2.253-3.221a2.272,2.272,0,1,0,2.272-2.321A2.312,2.312,0,0,0,252.164,24.95Z",
    transform: "translate(-229.28 -4.45)",
    fill: "#50b2dc",
    stroke: "#50b2dc",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user-blue.92250531e1c6b95c6c1723e7e347f7a3.svg";
export { ForwardRef as ReactComponent };